
const lastUpdate = '2026-03-15';
export const helpTitle = 'Wildfire Explorer';

export const helpContent = `
<h1>${helpTitle}</h1>

<h2>Overview</h2>
<p>The Wildfire Explorer provides access to current and historical wildfire records. Use it to monitor active fires, review past seasons, and access fire-specific data and models.</p>

<h2>Browsing Fires</h2>
<ul>
  <li>Fires are listed in a grid — click any fire to open its detail panel.</li>
  <li>The detail panel shows fire statistics, associated models, and linked files.</li>
  <li>Use the <strong>Filter</strong> controls to narrow by status, region, or date range.</li>
</ul>

<h2>Stats Dashboard</h2>
<p>The statistics dashboard summarizes fire activity across four periods:</p>
<ul>
  <li><strong>Today</strong> — Fires reported or updated today.</li>
  <li><strong>Current Year</strong> — Season totals to date.</li>
  <li><strong>10-Year Average</strong> — Historical benchmark for comparison.</li>
  <li><strong>Historical</strong> — All-time records.</li>
</ul>

<h2>Tips</h2>
<ul>
  <li>Click a fire on the map to jump to its record in the explorer.</li>
  <li>Use the <strong>Status</strong> filter to show only active, held, or under control fires.</li>
</ul>

<div class="last-update">Last Updated: ${lastUpdate}</div>
`;

export default helpContent;
